module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/app-8226689c1ca095fb1ad34838997c18e9.webp";